export const RUSTORE_APP_URL = 'https://www.rustore.ru/catalog/app/com.lupa.mobile?utm_source=available_in_rustore&utm_medium=com.lupa.mobile&rsm=1&mt_link_id=iios36&mt_sub1=com.lupa.mobile'
